module.exports = __webpack_public_path__ + "img/Be_You.a4850e75.gif";